import React, { FC, useMemo } from 'react';
import { Stack } from '@mui/material';

import { StyledCellText } from 'molecules/Table/styles/Text.styles';
import { ApprovalInvoiceService } from './types';

type LateFeeDescriptionsProps = {
  services: ApprovalInvoiceService[];
};

const LateFeeDescriptions: FC<LateFeeDescriptionsProps> = ({ services }) => {
  const descriptions = useMemo(
    () =>
      services
        .map(({ description }) => description?.trim())
        .filter((description): description is string => Boolean(description)),
    [services]
  );

  return (
    <Stack spacing={1} sx={{ px: 7, py: 2, alignItems: 'flex-start' }}>
      {descriptions.length > 0 ? (
        descriptions.map((description, index) => (
          <StyledCellText
            // Descriptions may repeat, so retain service order in the key.
            // eslint-disable-next-line react/no-array-index-key
            key={`${description}-${index}`}
            data-testid="late-fee-description"
            sx={{
              overflow: 'visible',
              overflowWrap: 'anywhere',
              textOverflow: 'clip',
              whiteSpace: 'pre-wrap',
            }}
          >
            {description}
          </StyledCellText>
        ))
      ) : (
        <StyledCellText>No description available.</StyledCellText>
      )}
    </Stack>
  );
};

export default LateFeeDescriptions;
